import React from "react";
import leftPng from "../../../../content/images/left.png";

const Detail = () => {
  return (
    <div id="detailSide" className="d-none">
      <div className="detail-title">Planning in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar Planning
          </a>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Gisratio Id</div>
            <div className="box-title-2-active" id="d-algemeen-gisratio" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Status</div>
            <div className="box-title-2" id="d-status" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Maatregel</div>
            <div className="box-title-2" id="d-maatregel-naam" />
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Werkplan</div>
            <div className="box-title-2" id="d-werkplan-naam" />
          </div>
        </div>

        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Planningspatroon</div>
            <div className="box-title-2" id="d-planningspatroon-naam" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Planningsperiode</div>
            <div className="box-title-2" id="d-planningsperiode-naam" />
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Budget</div>
            <div className="box-title-2" id="d-budget-naam" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Beheereenheid</div>
            <div className="box-title-2" id="d-beheereenheid-naam" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Laag</div>
            <div className="box-title-2" id="d-beheeractiviteit-laag" />
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Discipline</div>
            <div className="box-title-2" id="d-discipline-naam" />
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Tijdstip verzonden</div>
            <div className="box-title-2" id="d-status-tijdstip_verzonden" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Detail;
